export const nftSort = (
  nfts: number[],
  sortedBy: "Ascending" | "Descending"
): number[] => {
  if (sortedBy === "Ascending") {
    return nfts.sort((a, b) => a - b);
  }
  if (sortedBy === "Descending") {
    return nfts.sort((a, b) => b - a);
  }
  return nfts;
};
